import { types } from 'mobx-state-tree';
import { LanguageCode, TLCode } from '../common/enums/';
import { GetText } from '../locales';
import { getEnvironment } from './utils';
import Cookie from 'js-cookie';

export const LocaleStore = types
  .model('LocaleStore', {
    currentLocale: types.optional(types.enumeration(Object.keys(LanguageCode)), () => {
      const detectedBrowserLocale = 'fr';
      return LanguageCode[LanguageCode[detectedBrowserLocale]] || LanguageCode[LanguageCode.en];
    }),
  })
  .actions((self) => {
    const env = getEnvironment(self);
    const cookieName = `${env.config.configName}_web_gardes_language`;
    return {
      setCurrentLocale(newLocale: string) {
        self.currentLocale = LanguageCode[LanguageCode[newLocale]] || LanguageCode[LanguageCode.en];
        Cookie.set(cookieName, self.currentLocale);
      },
      afterAttach() {
        const cookieLanguage = Cookie.get(cookieName);
        if (cookieLanguage) {
          self.currentLocale = LanguageCode[LanguageCode[cookieLanguage]] || LanguageCode[LanguageCode.en];
        }
      },
    };
  })
  .views((self) => ({
    get allLocales() {
      return Object.keys(LanguageCode)
        .map((k) => LanguageCode[k])
        .filter((i) => typeof i === 'string');
    },
    getText(code: TLCode) {
      return GetText(code, self.currentLocale);
    },
  }));
